/* =========================================================================
    REVISION REQUEST FORM AUTO-SYNC
 ========================================================================= */
(function () {
    let revisionRecordId = null;
    let revisionDebounceTimer = null;
    let isRevisionCreating = false;
    let revisionCreationPromise = null;
    let revisionSessionId = 0;

    function resetRevisionSyncState() {
        revisionSessionId++;
        clearTimeout(revisionDebounceTimer);
        revisionDebounceTimer = null;
        revisionRecordId = null;
        isRevisionCreating = false;
        revisionCreationPromise = null;
    }
    window.resetRevisionSyncState = resetRevisionSyncState;

    // Called after a revision request is successfully submitted — flags the
    // Airtable record with sent_to_at so the backend can branch on its presence.
    window.markRevisionSentToAt = function () {
        const recordId = revisionRecordId;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/revision/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    sent_to_at: true,
                    location: getStoredLocation(),
                    project: 'Signage.inc'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Revision Live Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Revision Live Sync sent_to_at Exception]:', err);
            });
        } catch (err) {
            console.error('[Revision Live Sync sent_to_at Exception]:', err);
        }
    };

    function getStoredLocation() {
        try {
            return localStorage.getItem('location') || '';
        } catch (e) {
            return '';
        }
    }

    // Extract form input data
    function getRevisionFormData() {
        // 1. Gather selected Sign Types (chips/buttons or dropdown)
        const selectedTypes = Array.from(
            document.querySelectorAll('#revisionModal .rev-sign-chip.is-selected, #revisionModal .sign-type-chip.selected, input[name="sign_type"]:checked, #revChangeType')
        ).map(el => (el.value || el.textContent || '').trim()).filter(Boolean);

        const hiddenSignInput = document.getElementById('revSignTypeInput');
        const signTypesStr = selectedTypes.length > 0
            ? selectedTypes.join(', ')
            : (hiddenSignInput ? hiddenSignInput.value.trim() : '');

        // 2. Gather "WHAT WOULD YOU LIKE TO CHANGE?" text
        const detailsEl = document.getElementById('revDetails') || document.querySelector('#revisionModal textarea, textarea[name="change_details"], textarea[name="details_of_change"]');
        const detailsVal = detailsEl ? detailsEl.value.trim() : '';

        return {
            type_of_sign: signTypesStr,
            change_details: detailsVal,
            payment_url: window.location.href,
            location: getStoredLocation(),
            project: 'Signage.inc' // Hardcoded Project Name for Airtable Single Select
        };
    }

    // Core Sync Function (Create or Update)
    async function syncRevisionData() {
        // Race-condition guard: Wait if initial creation request is still pending
        if (isRevisionCreating && revisionCreationPromise) {
            try {
                await revisionCreationPromise;
            } catch (e) {
                // Ignore initial error to allow retry
            }
        }

        const data = getRevisionFormData();

        // Do not submit if both fields are empty
        if (!data.type_of_sign && !data.change_details) {
            return;
        }

        const doFetch = async () => {
            const thisSession = revisionSessionId;
            const isUpdate = Boolean(revisionRecordId);
            const endpoint = isUpdate
                ? 'https://webhooks.codeblue.agency/api/revision/update'
                : 'https://webhooks.codeblue.agency/api/revision/create';

            const payload = {
                ...data,
                project: 'Signage.inc' // Hardcoded Project Name for Airtable Single Select
            };

            if (isUpdate && revisionRecordId) {
                payload.record_id = revisionRecordId;
            }

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (thisSession === revisionSessionId) {
                        if (!revisionRecordId && result.record_id) {
                            revisionRecordId = result.record_id;
                            console.log('[Revision Live Sync] Created Airtable Record ID:', revisionRecordId);
                        } else {
                            console.log('[Revision Live Sync] Updated Airtable Record ID:', revisionRecordId);
                        }
                    }
                    return result;
                } else {
                    console.error('[Revision Live Sync Error]:', result);
                }
            } catch (err) {
                console.error('[Revision Live Sync Exception]:', err);
            }
        };

        const initialRecordId = revisionRecordId;
        if (!initialRecordId && !isRevisionCreating) {
            isRevisionCreating = true;
            revisionCreationPromise = doFetch().finally(() => {
                isRevisionCreating = false;
                revisionCreationPromise = null;
            });
            return revisionCreationPromise;
        } else {
            return doFetch();
        }
    }

    // Debounced listener (Fast 500ms initial creation, 2000ms update debounce)
    function handleRevisionLiveInput() {
        clearTimeout(revisionDebounceTimer);
        const delay = revisionRecordId ? 2000 : 500;
        revisionDebounceTimer = setTimeout(() => {
            syncRevisionData();
        }, delay);
    }
    window.triggerRevisionAutoSync = handleRevisionLiveInput;

    // Global Event Delegation for Revision Modal
    document.addEventListener('input', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target && e.target.closest('#revisionModal .rev-sign-chip, #revisionModal .sign-type-chip, #revisionModal .type-select-btn')) {
            handleRevisionLiveInput();
        }
    });

    // Final "complete" signal — fired on modal close (or successful submit).
    // Cancels any pending debounce and, if a record exists for this session,
    // flags it as closed/finalized so Airtable doesn't show it as abandoned.
    async function completeRevisionSync() {
        clearTimeout(revisionDebounceTimer);
        revisionDebounceTimer = null;

        const recordIdToComplete = revisionRecordId;
        if (recordIdToComplete) {
            try {
                await fetch('https://webhooks.codeblue.agency/api/revision/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        record_id: recordIdToComplete,
                        project: 'Signage.inc',
                        location: getStoredLocation(),
                        status: 'Completed'
                    })
                });
                console.log('[Revision Live Sync] Finalized Airtable Record ID:', recordIdToComplete);
            } catch (err) {
                console.error('[Revision Live Sync] Complete signal failed:', err);
            }
        }

        resetRevisionSyncState();
    }
    window.completeRevisionSync = completeRevisionSync;
})();
